import CARDICT from '@/store/dict/carDict.js'
import moment from 'moment'
import { verifyFun } from '@/utils'
import {
  getCarDetails,
  getCityList,
  getDrivingInfo,
  getRegistration,
  editCar,
  getRideHailing,
  getCarInfo,
  FuzzySearch,
  getCarStandardDataList,
} from '@/api/domain/cars'
import { validateCarVin, validateTipMsg } from '@/utils/extendFormVaildate.js'
import { CAR_MODEL_FILTER_SCENE } from '@/config/carManage'
import { getSimpleCarList, getCarDetailById } from '@/api/carManage/index.js'

export default {
  components: {},
  data() {
    return {
      tagList: [], // 选中的自定义标签列表（用户选中，传给服务用）
      currentTagList: [], // 已经选中的自定义标签列表（详情查询出来的）
      relatedPurchaseOrderTableData: [],
      relatedEnterpriseLeasingTableData: [],
      oLoading: {
        detail: false,
        submit: false,
        fuzzySearch: false,
      },
      pageTitle: '',
      carId: '',
      // 驾驶证
      drivingImg: {
        main: [],
        back: [],
        viceBack: [],
      },
      // 自定义图片
      customImg: [],
      // 网约车证照
      networkImg: [],
      // 登记证
      registrationImg: [],
      // 登记证副页
      registrationSecondImg: [],
      // 注册地
      cityList: [],
      carMessage: '',
      carState: '', // 5：待入库
      // 因为表单需要多个对象的属性组合，所以先拼接一个
      carInfoPage: {
        modelId: '', // 车型ID
        managerId: '', // 车管ID
        purchaseType: '', // 采购方式
        vin: '', // 车架号VUN码
        plateNo: '', // 车牌号
        engineNo: '', // 发动机号
        registDate: '', // 注册日期
        inspectDate: '', // 年检有效期
        scrapDate: '', // 强制报废日期
        usage: '', // 使用性质  1营运 2非营运
        property: '', // 车辆属性   1个人  2公司
        type: '', // 车辆类型  1大型汽车/2小型汽车/3专用汽车/4特种车/5无轨电车/6有轨电车/7电瓶车/8三轮摩托车/9两轮摩托车/100其他
        color: '', // 车辆颜色
        registPlace: '', // 车辆注册地
        seats: '', // 核定载客人数
        issueOrgan: '', // 行驶证发证机关
        remarks: '', // 备注
        propertyId: '', // 车源方
        energyType: '', // 备注
        storagePlace: '', // 存放地
      },
      carColor: [
        // 车型ID
        { key: 1, state: 1, parentKey: 'carLicenseInfo', props: 'modelId' },
        { key: 2, state: 1, parentKey: 'carLicenseInfo', props: 'vin' },
        { key: 3, state: 1, parentKey: 'carLicenseInfo', props: 'plateNo' },
        { key: 4, state: '', parentKey: 'carLicenseInfo', props: 'engineNo' },
        // 行驶证正面
        { key: 5, state: '', parentKey: 'drivingImg', props: 'main' },
        // 行驶证反
        { key: 6, state: '', parentKey: 'drivingImg', props: 'back' },
        // 注册日期
        { key: 7, state: '', parentKey: 'carInfo', props: 'registDate' },
        {
          key: 8,
          state: '',
          parentKey: 'carLicenseInfo',
          props: 'inspectDate',
        },
        { key: 9, state: '', parentKey: '', props: 'registrationImg' },
        { key: 10, state: '', parentKey: '', props: 'networkImg' },
        {
          key: 11,
          state: '',
          parentKey: 'carTransportLicense',
          props: 'expiryDate',
        },
        {
          key: 12,
          state: '',
          parentKey: 'carLicenseInfo',
          props: 'storagePlace',
        },
        { key: 13, state: '', parentKey: 'carLicenseInfo', props: 'color' },
        { key: 14, state: '', parentKey: 'carLicenseInfo', props: 'seats' },
      ],
      carInfo: {
        modelId: '', // 车型ID
        registPlace: '', // 车辆注册地
        registDate: '', // 注册日期
      },
      // 行驶证
      carLicenseInfo: {
        vin: '', // 车架号VUN码
        brandId: '',
        seriesId: '',
        modelId: '', // 车型
        plateNo: '', // 车牌号
        originalPlateNo: '', // 原车牌
        type: '', // 车辆类型  1大型汽车/2小型汽车/3专用汽车/4特种车/5无轨电车/6有轨电车/7电瓶车/8三轮摩托车/9两轮摩托车/100其他
        property: '', // 车辆属性   1个人  2公司
        usage: '', // 使用性质  1营运 2非营运
        usageDate: '', // 车辆性质变更时间
        issueOrgan: '', // 行驶证发证机关
        engineNo: '', // 发动机号
        issueDate: '', // 行驶证发证日期
        seats: '', // 核定载客人数
        inspectDate: '', // 年检有效期
        scrapDate: '', // 强制报废日期
        receiveDate: '', // 行驶证领取记录-领取日期
        receivePlace: '', // 行驶证领取记录-领取地点
        licenseReceiver: '', // 行驶证领取记录-领取人
        drivingLicenseNo: '', // 行驶证档案号
        totalMass: '', // 总质量
        kerbWeight: '', // 整备质量
        approvedLoad: '', // 核定载质量
        overallSize: '', // 外廓尺寸
        tractionMass: '', // 准牵引总质量
        photo: '', // 行驶证照片
        licenseRemarks: '', // 行驶证备注
        subLicenseBackPhoto: '', // 行驶证副页
        registDate: '', // 注册日期
        owner: '', // 所有人
        ownerAddress: '', // 住址
        record: '', // ocr扫描出的检验记录
        brandSeriesModel: {},
      },
      // 网约车证
      carTransportLicense: {
        registDate: '', // 登记日期
        effectDate: '', // 有效期开始日期
        expiryDate: '', // 有效期截止日期
        transportLicenseNo: '', // 交运管许可字号
        bizScope: '', // 经营范围
        issueOrgan: '', // 网约车发证机关
        photo: '', // 网约车证照片
      },
      // 登记证
      carRegistCertInfo: {
        registNo: '', // 登记编号
        productionDate: '', // 出厂日期
        issueDate: '', // 发证日期
        acquisitionMode: '', // 车辆获得方式
        registOrgan: '', // 发证机关
        photo: '', // 登记证照片
        subRegisterCertPhotos: '', // 登记证副页
      },
      // 10个图片上传
      aloneFileUpload: [
        {
          key: 'load1',
          txt: '左前45°',
          data: [],
        },
        {
          key: 'load2',
          txt: '右后45°',
          data: [],
        },
        {
          key: 'load3',
          txt: '发动机舱',
          data: [],
        },
        {
          key: 'load4',
          txt: '车顶',
          data: [],
        },
        {
          key: 'load5',
          txt: '前排座椅',
          data: [],
        },
        {
          key: 'load6',
          txt: '后排座椅',
          data: [],
        },
        {
          key: 'load7',
          txt: '中控台',
          data: [],
        },
        {
          key: 'load8',
          txt: '车内顶棚',
          data: [],
        },
        {
          key: 'load9',
          txt: '车钥匙',
          data: [],
        },
        {
          key: 'load10',
          txt: '后备箱',
          data: [],
        },
      ],
      carRules: {
        modelId: [
          {
            required: true,
            message: '车型不能为空',
            trigger: 'blur',
          },
        ],
      },
      carLicenseRules: {
        vin: [
          {
            required: true,
            message: '车辆VIN码不能为空',
            trigger: 'blur',
          },
          {
            validator: validateCarVin,
            trigger: 'change',
          },
        ],
        modelId: [
          {
            required: true,
            message: '车型不能为空',
            trigger: 'change',
          },
        ],
        plateNo: [
          {
            required: true,
            message: '车牌号不能为空',
            trigger: 'change',
          },
        ],
      },
      // 当前展开面板
      activeNames: [
        'base_info',
        'driver_license_info',
        'hadling_info',
        'registration',
      ],
      backTip: false,
      vinList: [], // 检索到的vin信息
      carList: [], // 检索到的车辆信息
      searchData: {
        plateNo: '',
      },
      searchCarId: '',
      CAR_MODEL_FILTER_SCENE,
    }
  },
  mounted() {
    const { id } = this.$route.query
    // 编辑
    if (id) {
      this.carId = parseInt(id)
      this.getCarDetails()
      this.pageTitle = '编辑证照'
    } else {
      this.getCarList()
      this.pageTitle = '新建证照'
    }
    // 注册地
    this.getCityList()

    // 获取待租标准
    this.getRentStandard()
  },
  watch: {
    'carLicenseInfo.registDate': {
      handler(val) {
        if (val) {
          this.carInfo.registDate = val
        }
      },
    },
    'carLicenseInfo.brandSeriesModel': {
      handler(val) {
        const { brandId, seriesId, modelId } = val
        this.carLicenseInfo.brandId = brandId
        this.carLicenseInfo.seriesId = seriesId
        this.carLicenseInfo.modelId = modelId
        if (brandId) {
          this.$refs.carLicenseInfoRef.clearValidate('brandId')
        } else {
          this.$refs.carLicenseInfoRef.validateField('brandId')
        }
        if (modelId) {
          this.$refs.carLicenseInfoRef.clearValidate('modelId')
        }
      },
      deep: true,
    },
  },
  methods: {
    // 车牌号选中
    async setPlateNo(item) {
      if (!item) {
        return
      }
      const carInfo = this.carList.find((v) => v.plateNo === item)
      if (!carInfo) {
        return
      }
      this.searchCarId = carInfo.id
      // 获取车辆信息
      const { data } = await getCarDetailById({ carId: carInfo.id })
      this.carLicenseInfo.vin = data.vin || ''
      this.carLicenseInfo.modelId = Number(data.modelId) || ''
      this.carLicenseInfo.brandSeriesModel = {
        brandId: data.brandId,
        seriesId: data.seriesId,
        modelId: data.modelId,
      }
    },
    // vin码选中
    setVin(item) {
      if (!item) {
        this.carList = []
        return
      }
      const carInfo = this.vinList.find((v) => v.vin === item)
      this.searchCarId = carInfo.id
      this.carLicenseInfo.plateNo = carInfo.plateNo || ''
      this.carList = [carInfo]
      this.carLicenseInfo.modelId = Number(carInfo.modelId) || ''
    },
    // 获取待租标准
    async getRentStandard() {
      const { carColor } = this
      const { code, data } = await getCarStandardDataList({})
      if (code !== 1) return
      const allFieldCol = [...data.carAndLicenseList, ...data.carMatterList]
      // 根据待租标准配置加粗标红字段
      allFieldCol.forEach((rent) => {
        const field = carColor.find(
          (v) => Number(v.key) === Number(rent.itemType),
        )
        field && (field.state = Number(rent.state))
      })
    },
    // 模糊搜索获取车牌号
    async getCarNoList(query) {
      query = query.trim()
      // 开启远程搜索
      if (query.length >= 1) {
        this.getCarList(query)
      }
    },
    async getCarList(query) {
      this.oLoading.fuzzySearch = true
      try {
        const { code, data } = await getSimpleCarList({
          plateNo: query,
          state: 2,
        })
        if (code === 1) {
          this.carList = data
        }
        // 关闭远程搜索
        this.oLoading.fuzzySearch = false
      } catch (error) {
        this.oLoading.fuzzySearch = false
      }
    },
    // 模糊搜索获取vin信息
    async gerVinList(query) {
      query = query.trim()
      // 开启远程搜索
      if (query.length >= 4) {
        this.oLoading.fuzzySearch = true
        try {
          const { code, data } = await FuzzySearch({
            vin: query,
            state: 1,
          })
          if (code === 1) {
            this.vinList = data
          }
          // 关闭远程搜索
          this.oLoading.fuzzySearch = false
        } catch (error) {
          this.oLoading.fuzzySearch = false
        }
      } else {
        this.vinList = []
      }
    },
    async getCityList() {
      try {
        const { code, data } = await getCityList()
        if (code === 1) {
          this.cityList = data
        } else {
          this.$message.error('获取城市列表失败')
        }
      } catch (error) {
        this.$message.error('获取城市列表失败')
      }
    },

    // 获取车辆详情
    async getCarDetails() {
      this.oLoading.detail = true
      try {
        const { code, data } = await getCarDetails({
          id: this.carId,
        })
        this.oLoading.detail = false
        if (code !== 1) return

        // 车辆基本信息
        if (data.carInfo) {
          Object.keys(data.carInfo).forEach((item) => {
            Object.keys(this.carInfo).forEach((carInfoItem) => {
              if (item === carInfoItem) {
                // 车辆信息赋值
                this.carInfo[carInfoItem] = data.carInfo[carInfoItem]
              }
            })
          })
          // 车辆基本状态信息
          this.carInfo.basicItemState = Number(data.carInfo.basicItemState)
          // this.carInfo.basicItemState = CARDICT.CAR_MESSAGE()[
          //   this.carInfo.basicItemState
          // ]
          this.carMessage = Number(data.carInfo.basicItemState)
          this.carLicenseInfo.modelId = data.carInfo.modelId
          this.carLicenseInfo.brandSeriesModel = {
            brandId: data.carInfo.brandId,
            seriesId: data.carInfo.seriesId,
            modelId: data.carInfo.modelId,
          }
          this.carState = data.carInfo.carState
        }

        // 行驶证信息
        if (data.carLicenseInfo) {
          Object.keys(data.carLicenseInfo).forEach((item) => {
            Object.keys(this.carLicenseInfo).forEach((infoItem) => {
              if (item === infoItem) {
                this.carLicenseInfo[infoItem] = data.carLicenseInfo[infoItem]
              }
            })
          })
          this.carLicenseInfo.registDate = data?.carInfo?.registDate
        }

        // 行驶证照片主页-new
        this.drivingImg.main = this.getEchoUploadFileData(
          data?.carLicenseInfo?.drivingLicense,
          true,
        )
        // 行驶证照片副页-new
        this.drivingImg.back = this.getEchoUploadFileData(
          data?.carLicenseInfo?.drivingSubLicense,
          true,
        )
        // 行驶证副页背面
        this.drivingImg.viceBack = this.getEchoUploadFileData(
          data?.carLicenseInfo?.subLicenseBackPhoto,
          true,
        )

        // 网约车证信息
        if (data.carTransportLicense) {
          Object.keys(data.carTransportLicense).forEach((item) => {
            Object.keys(this.carTransportLicense).forEach((infoItem) => {
              if (item === infoItem) {
                this.carTransportLicense[infoItem] =
                  data.carTransportLicense[infoItem]
              }
            })
          })
        }

        // 网约车证照片
        this.networkImg = this.getEchoUploadFileData(
          data?.carTransportLicense?.photo,
          true,
        )

        // 登记证信息
        if (data.carRegistCertInfo) {
          Object.keys(data.carRegistCertInfo).forEach((item) => {
            Object.keys(this.carRegistCertInfo).forEach((infoItem) => {
              if (item === infoItem) {
                this.carRegistCertInfo[infoItem] =
                  data.carRegistCertInfo[infoItem]
              }
            })
          })
        }

        // 登记证照片
        this.registrationImg = this.getEchoUploadFileData(
          data?.carRegistCertInfo?.photo,
          true,
        )
        // 登记证副页
        this.registrationSecondImg = this.getEchoUploadFileData(
          data?.carRegistCertInfo?.subRegisterCertPhotos,
          true,
        )
      } catch (error) {
        // this.$message.error('数据请求失败')
        console.log('证照', error)
      }

      // 编辑态进行注册日期的标红和必填校验注入
      for (const item of this.carColor) {
        // 【注册日期】、【核定载荷人数】在编辑态变成必填项目
        if (['registDate', 'seats'].includes(item.props)) {
          item.state = 1
        }
      }
      //  设置字段的必填rules
      this.$set(this.carLicenseRules, 'registDate', [
        { required: true, message: '请选择注册日期', trigger: 'change' },
      ])
      this.$set(this.carLicenseRules, 'seats', [
        { required: true, message: '请输入核定载客人数', trigger: 'change' },
      ])
    },

    // 新增 / 编辑
    async addHandle(type) {
      try {
        let validResult = await Promise.all([
          new Promise((resolve) => {
            this.$refs.carLicenseInfoRef.validate((valid, ruleObj) => {
              if (!valid) {
                resolve(validateTipMsg(ruleObj))
              }
              resolve(null)
            })
          }),
        ])
        validResult = validResult.flat(Infinity).filter((v) => v !== null)
        const len = validResult.length
        if (len === 0) {
          this.submitHandle(type)
          return
        }
        if (len > 0 && len <= 3) {
          const tipMsg = validResult.map((v) => v.replace('不能为空', ''))
          this.$message.error(`请填写必填项「${tipMsg.join('、')}」`)
        }
        len > 3 && this.$message.error('请填写必填项')
      } catch (error) {
        console.log(error)
      }
    },
    // 保存发送请求操作
    submitHandle(type) {
      this.getSubmitPhoto()
      // 编辑
      if (type === 2 && this.carId) {
        this.carInfo.id = this.carId
        this.oLoading.submit = true
        const { modelId } = this.carLicenseInfo
        editCar({
          carInfo: { id: this.carId, ...this.carInfo, modelId },
          carLicenseInfo: this.carLicenseInfo,
          carTransportLicense: this.carTransportLicense,
          carRegistCertInfo: this.carRegistCertInfo,
          // 1「仅编辑」2「确认到库」
          editSourceType: 1,
        }).then(({ code }) => {
          this.oLoading.submit = false
          if (code === 1) {
            this.$message.success('操作成功')
            this.goCarLicence()
          }
        }).catch(() => {
          this.oLoading.submit = false
        })
      } else if (type === 1) {
        if (!this.searchCarId) {
          this.$message.error('VIN不存在，请完成车辆录入后编辑证照信息!')
          return
        }
        this.carInfo.id = this.searchCarId
        this.oLoading.submit = true
        const { modelId } = this.carLicenseInfo
        editCar({
          carInfo: { id: this.searchCarId, ...this.carInfo, modelId },
          carLicenseInfo: this.carLicenseInfo,
          carTransportLicense: this.carTransportLicense,
          carRegistCertInfo: this.carRegistCertInfo,
          // 1「仅编辑」2「确认到库」
          editSourceType: 1,
        })
          .then(({ code }) => {
            this.oLoading.submit = false
            if (code === 1) {
              this.$message.success('操作成功')
              this.goCarLicence()
            }
          })
          .catch(() => {
            this.oLoading.submit = false
          })
      }
    },

    /**
     * 根据车牌号/VIN码查车辆id
     * @param {object} params
     */
    async getCarIdByPlatNo(params) {
      const { code, data } = await getCarInfo(params)
      if (code !== 1) {
        this.$message.error('车辆信息查询失败！')
        return
      }
      return data?.carId || null
    },
    // 驾驶证主页orc成功事件
    drivingImgMainSuccess(url) {
      this.oLoading.detail = true
      getDrivingInfo({
        imageUrl: url,
        cardSide: 'FRONT',
      })
        .then(({ data }) => {
          this.oLoading.detail = false
          if (data?.frontInfo) {
            this.setCarInfoPage(data.frontInfo) // 处理数据
          }
        })
        .catch(() => {
          this.oLoading.detail = false
        })
    },

    // 处理数据
    async setCarInfoPage(data) {
      if (
        this.isEdit &&
        (this.carLicenseInfo.plateNo !== data.plateNo ||
          this.carLicenseInfo.vin !== data.vin)
      ) {
        return
      }
      // 发证日期
      const isd = verifyFun(data.issueDate)
      this.carLicenseInfo.issueDate = isd === 'Invalid date' ? '' : isd
      // 车牌号
      this.carLicenseInfo.plateNo = data.plateNo || ''

      this.carLicenseInfo.owner = data?.owner
      this.carLicenseInfo.ownerAddress = data?.address

      // 根据车牌号查id
      if (data.plateNo) {
        this.getCarNoList(data.plateNo)
        this.searchCarId = await this.getCarIdByPlatNo({
          plateNo: data.plateNo,
          vin: '',
        })
      }
      // vin码
      this.carLicenseInfo.vin = data.vin
      if (data.vin) {
        this.searchCarId = await this.getCarIdByPlatNo({
          plateNo: '',
          vin: data.vin,
        })
      }
      // 发动机号码
      this.carLicenseInfo.engineNo = data.engineNo
      // 车辆类型
      this.carLicenseInfo.type = parseInt(data.vehicleType, 10) || ''
      // 使用性质
      if (data.useCharacter) {
        this.carLicenseInfo.usage = parseInt(data.useCharacter, 10)
      } else {
        this.carLicenseInfo.usage = ''
      }
      // 注册日期
      if (data.registerDate) {
        this.carInfo.registDate = moment(parseInt(data.registerDate, 10)).format(
          'yyyy-MM-DD',
        )
        this.carLicenseInfo.registDate = moment(
          parseInt(data.registerDate, 10),
        ).format('yyyy-MM-DD')
      } else {
        this.carInfo.registDate = ''
        this.carLicenseInfo.registDate = ''
      }
      // 发证机关
      this.carLicenseInfo.issueOrgan = data.seal
    },
    // 驾驶证副页orc成功事件
    drivingImgBackSuccess(url) {
      this.oLoading.detail = true
      getDrivingInfo({
        imageUrl: url,
        cardSide: 'BACK',
      })
        .then(({ data }) => {
          this.oLoading.detail = false
          if (data?.backInfo) {
            this.setDrivingBackData(data.backInfo)
          }
        })
        .catch(() => {
          this.oLoading.detail = false
        })
    },
    // 设置ocr驾驶正反面信息
    async setDrivingBackData(data) {
      if (this.isEdit && this.carLicenseInfo.plateNo !== data.plateNo) {
        return
      }
      this.carLicenseInfo.licenseRemarks = data.marks
      this.carLicenseInfo.seats = data.seats - 0 || data.allowNum - 0
      this.carLicenseInfo.plateNo = data.plateNo || ''

      this.carLicenseInfo.drivingLicenseNo = data?.fileNo
      // tractionMass 准牵引总质量
      this.carLicenseInfo.tractionMass = data.totalQuasiMass || ''
      if (data.plateNo) {
        this.getCarNoList(data.plateNo)
        this.searchCarId = await this.getCarIdByPlatNo({
          plateNo: data.plateNo,
          vin: '',
        })
      }
      // 总质量
      this.carLicenseInfo.totalMass = data.totalMass || ''
      // 整备质量
      this.carLicenseInfo.kerbWeight = data.curbWeight || ''
      // 外廓尺寸
      this.carLicenseInfo.overallSize = data.externalSize || ''

      this.carLicenseInfo.record = data.record || ''

      // 截取有效期
      if (data.record) {
        const _date = data.record.replace(/[^0-9]/gi, '')
        const _year = _date.substr(0, 4)
        const _month = _date.substr(4, 2)
        const _day = moment(`${_year}-${_month}-01`)
          .endOf('month')
          .format('DD')
        this.carInfoPage.inspectDate =
          (_year && _month && `${_year}-${_month}-${_day}`) || ''
      }
    },

    // 网约车证件orc成功事件
    networkImgSuccess(url) {
      this.oLoading.detail = true
      getRideHailing({
        imageUrl: url,
      })
        .then(({ code, data }) => {
          this.oLoading.detail = false
          if (code === 1) {
            this.setnetworkInfo(data)
          }
        })
        .catch(() => {
          this.oLoading.detail = false
        })
    },

    // 设置网约车证信息
    setnetworkInfo(data) {
      this.carTransportLicense.registDate = this.dateStr(data.releaseDate)
      this.carTransportLicense.effectDate = this.dateStr(data.startDate)
      this.carTransportLicense.transportLicenseNo = data.operationLicenseNumber
      this.carTransportLicense.expiryDate = this.dateStr(data.endDate)
    },

    dateStr(val) {
      const date = verifyFun(val)
      return date === 'Invalid date' ? '' : date
    },

    // 登记证orc成功事件
    async registrationSuccess(url) {
      this.oLoading.detail = true
      const { code, data } = await getRegistration({ imageUrl: url })
      this.oLoading.detail = false
      if (code !== 1) return
      if (data?.regCertInfo) {
        this.setRegistCertInfo(data.regCertInfo)
      }
    },
    // 登记证副页成功 vice
    registrationViceSuccess() {
      this.registrationSecondImg.forEach((ele) => {
        ele.title = '登记证副页'
      })
    },

    // 设置网页登记证信息
    setRegistCertInfo(data) {
      this.checkInfoCorrect({
        plateNo: data.机动车登记编号1,
        vin: data['车辆识别代号/车架号'],
        engineNo: data.发动机号,
      })
      this.carRegistCertInfo.registNo = data.编号?.replace(/^\*|\*$/g, '')
      const productionDate = verifyFun(data.车辆出厂日期)
      const issueDate = verifyFun(data.发证日期)
      this.carRegistCertInfo.productionDate =
        productionDate === 'Invalid date' ? '' : productionDate
      this.carRegistCertInfo.issueDate =
        issueDate === 'Invalid date' ? '' : issueDate
      this.carRegistCertInfo.acquisitionMode = data.车辆获得方式
      this.carRegistCertInfo.registOrgan = data.登记机关1
    },

    // 不同的OCR如果检查出车牌号，vin，发动机号是否存在，不存在赋值，存在不一致提示信息不一致
    checkInfoCorrect(data) {
      const _arrMessage = []
      if (!this.carLicenseInfo.plateNo) {
        this.carLicenseInfo.plateNo = data.plateNo
      } else if (data !== this.carLicenseInfo.plateNo) {
        _arrMessage.push('车牌号')
      }

      // Vin

      if (!this.carLicenseInfo.vin) {
        this.carLicenseInfo.vin = data.vin
      } else if (data !== this.carLicenseInfo.vin) {
        _arrMessage.push('vin码')
      }

      // 发动机

      if (!this.carLicenseInfo.engineNo) {
        this.carLicenseInfo.engineNo = data.engineNo
      } else if (data !== this.carLicenseInfo.engineNo) {
        _arrMessage.push('发动机号')
      }

      if (_arrMessage.length) {
        const _str = _arrMessage.join(',')
        this.$confirm(
          `当前登记证照检测ocr识别${_str}信息与已填写车辆信息信息不一致，请检查！`,
          '提示',
          {
            confirmButtonText: '确定',
            showCancelButton: false,
            type: 'warning',
          },
        )
      }
    },

    // 获取页面上所有图片
    getSubmitPhoto() {
      // 行驶证主页
      this.carLicenseInfo.drivingLicense = this.getUoloadCommonFileData(
        this.drivingImg.main,
      )
      // 行驶证副页
      this.carLicenseInfo.drivingSubLicense = this.getUoloadCommonFileData(
        this.drivingImg.back,
      )
      // 副页背面
      this.carLicenseInfo.subLicenseBackPhoto = this.getUoloadCommonFileData(
        this.drivingImg.viceBack,
      )
      // 网约车证
      this.carTransportLicense.photo = this.getUoloadCommonFileData(
        this.networkImg,
      )
      // 登记证照片
      this.carRegistCertInfo.photo = this.getUoloadCommonFileData(
        this.registrationImg,
      )
      const reverseData = []
      this.registrationSecondImg.forEach((ele) => reverseData.unshift(ele))
      // 登记证副页照片
      this.carRegistCertInfo.subRegisterCertPhotos = this.getUoloadCommonFileData(
        reverseData,
      )
    },

    // 验证是否有编辑内容
    confirmBack() {
      const {
        carInfo,
        carLicenseInfo,
        drivingImg: { main, back },
        carTransportLicense,
        carRegistCertInfo,
        networkImg,
        registrationImg,
      } = this
      let hasValue = false
      // 车辆基本信息
      for (const car_info_key in carInfo) {
        if (carInfo[car_info_key]) {
          hasValue = true
          break
        }
      }
      // 行驶证信息
      for (const car_license_key in carLicenseInfo) {
        if (carLicenseInfo[car_license_key]) {
          hasValue = true
          break
        }
      }
      // 行驶证图片
      (main.length > 0 || back.length > 0) && (hasValue = true)

      // 网约车证信息
      for (const car_transport_key in carTransportLicense) {
        if (carTransportLicense[car_transport_key]) {
          hasValue = true
          break
        }
      }
      // 网约车证图片
      networkImg.length > 0 && (hasValue = true)

      // 登记证信息
      for (const car_reg_key in carRegistCertInfo) {
        if (carRegistCertInfo[car_reg_key]) {
          hasValue = true
          break
        }
      }
      // 登记证图片
      registrationImg.length > 0 && (hasValue = true)

      hasValue ? (this.backTip = true) : this.goPageBack()
    },

    // 返回上一级页面
    goPageBack(status = false) {
      this.backTip = false
      this.$refreshBack(status)
    },
    // 点击跳到证照列表
    goCarLicence() {
      this.$refreshBack(true)
      this.$router.push({
        path: '/vehicle/licences/list',
      })
    },
  },
  computed: {
    // 时间范围 默认前后十年
    timeLimit() {
      const _date = new Date()
      const tenYearsAgo = `${_date.getFullYear() - 10}-${_date.getMonth() +
        1}-${_date.getDate()}`
      const tenYearsAfter = `${_date.getFullYear() -
        0 +
        10}-${_date.getMonth() + 1}-${_date.getDate()}`
      return {
        ago: new Date(tenYearsAgo).getTime(),
        after: new Date(tenYearsAfter).getTime(),
      }
    },
    // 车辆信息-注册日期
    carInfoRegistDate() {
      return {
        disabledDate: (time) => {
          const { inspectDate } = this.carLicenseInfo // 年检有效期
          const { scrapDate } = this.carLicenseInfo // 强制报废
          time = time.getTime()
          if (inspectDate && scrapDate) {
            return (
              time < this.timeLimit.ago ||
              time > this.timeLimit.after ||
              time > new Date(inspectDate).getTime() ||
              time > new Date(scrapDate).getTime()
            )
          }

          if (inspectDate) {
            return (
              time < this.timeLimit.ago ||
              time > this.timeLimit.after ||
              time > new Date(inspectDate).getTime()
            )
          }

          if (scrapDate) {
            return (
              time < this.timeLimit.ago ||
              time > this.timeLimit.after ||
              time > new Date(scrapDate).getTime()
            )
          }

          return time < this.timeLimit.ago || time > this.timeLimit.after
        },
      }
    },
    // 车辆信息-年检有限期
    carInfoInspectDate() {
      return {
        disabledDate: (time) => {
          time = time.getTime()
          const { registDate } = this.carInfo // 注册日期
          if (registDate) {
            return (
              time < this.timeLimit.ago ||
              time > this.timeLimit.after ||
              time < new Date(registDate).getTime()
            )
          }
          return time < this.timeLimit.ago || time > this.timeLimit.after
        },
      }
    },
    // 车辆信息-强制报废日期
    carInfoScrapDate() {
      return {
        disabledDate: (time) => {
          time = time.getTime()
          const { registDate } = this.carInfo // 注册日期
          if (registDate) {
            return (
              time < this.timeLimit.ago ||
              time > this.timeLimit.after ||
              time < new Date(registDate).getTime()
            )
          }

          return time < this.timeLimit.ago || time > this.timeLimit.after
        },
      }
    },
    // 网约车证-登记日期
    netWorkRegistDate() {
      return {
        disabledDate: (time) => {
          const { effectDate } = this.carTransportLicense // 有效期开始日期
          const { expiryDate } = this.carTransportLicense // 有效期截止日期
          time = time.getTime()

          if (effectDate && expiryDate) {
            return (
              time < this.timeLimit.ago ||
              time > this.timeLimit.after ||
              time > new Date(effectDate).getTime() ||
              time > new Date(expiryDate).getTime()
            )
          }

          if (effectDate) {
            return (
              time < this.timeLimit.ago ||
              time > this.timeLimit.after ||
              time > new Date(effectDate).getTime()
            )
          }

          if (expiryDate) {
            return (
              time < this.timeLimit.ago ||
              time > this.timeLimit.after ||
              time > new Date(expiryDate).getTime()
            )
          }

          return time < this.timeLimit.ago || time > this.timeLimit.after
        },
      }
    },
    // 网约车证-有效期开始日期
    netWorkEffectDate() {
      return {
        disabledDate: (time) => {
          const { registDate } = this.carTransportLicense // 登记日期
          const { expiryDate } = this.carTransportLicense // 有效期截止日期
          time = time.getTime()

          if (registDate && expiryDate) {
            return (
              time < this.timeLimit.ago ||
              time > this.timeLimit.after ||
              time < new Date(registDate).getTime() ||
              time > new Date(expiryDate).getTime()
            )
          }

          if (registDate) {
            return (
              time < this.timeLimit.ago ||
              time > this.timeLimit.after ||
              time < new Date(registDate).getTime()
            )
          }

          if (expiryDate) {
            return (
              time < this.timeLimit.ago ||
              time > this.timeLimit.after ||
              time > new Date(expiryDate).getTime()
            )
          }

          return time < this.timeLimit.ago || time > this.timeLimit.after
        },
      }
    },
    // 网约车证-有效期截至日期
    netWorkExpiryDate() {
      return {
        disabledDate: (time) => {
          const { registDate } = this.carTransportLicense // 登记日期
          const { effectDate } = this.carTransportLicense // 有效期开始日期
          time = time.getTime()

          if (registDate && effectDate) {
            return (
              time < this.timeLimit.ago ||
              time > this.timeLimit.after ||
              time < new Date(registDate).getTime() ||
              time < new Date(effectDate).getTime()
            )
          }

          if (registDate) {
            return (
              time < this.timeLimit.ago ||
              time > this.timeLimit.after ||
              time < new Date(registDate).getTime()
            )
          }

          if (effectDate) {
            return (
              time < this.timeLimit.ago ||
              time > this.timeLimit.after ||
              time < new Date(effectDate).getTime()
            )
          }

          return time < this.timeLimit.ago || time > this.timeLimit.after
        },
      }
    },

    // 登记证-出厂日期
    carRegistProductionDate() {
      return {
        disabledDate: (time) => {
          time = time.getTime()
          const { issueDate } = this.carRegistCertInfo
          if (issueDate) {
            return (
              time < this.timeLimit.ago ||
              time > this.timeLimit.after ||
              time > new Date(issueDate).getTime()
            )
          }
          return time < this.timeLimit.ago || time > this.timeLimit.after
        },
      }
    },

    // 登记证-发证日期
    carRegistIssueDate() {
      return {
        disabledDate: (time) => {
          time = time.getTime()
          const { productionDate } = this.carRegistCertInfo
          if (productionDate) {
            return (
              time < this.timeLimit.ago ||
              time > this.timeLimit.after ||
              time < new Date(productionDate).getTime()
            )
          }
          return time < this.timeLimit.ago || time > this.timeLimit.after
        },
      }
    },
    // 车辆类型
    carTypeList() {
      return this.dictParseList(CARDICT.CAR_TYPE_DICT())
    },
    // 采购方式
    procurementList() {
      return this.dictParseList(CARDICT.CAR_PROCUREMENT_DICT())
    },
    // 颜色列表
    colorList() {
      return this.dictParseList(CARDICT.CAR_COLOR_DICT())
    },
    // 能源类型
    energyTypeList() {
      return this.dictParseList(CARDICT.ENERGY_TYPE_LIST())
    },
    // 使用性质
    useList() {
      return this.dictParseList(CARDICT.CAR_USE_DICT())
    },
    // 车辆属性
    attrubuteList() {
      return this.dictParseList(CARDICT.CAR_ATTRIBUTE_DICT())
    },
    // 加粗标红
    RedBlod() {
      return (props) => {
        const field = this.carColor.find((item) => item.props === props)
        return field?.state === 1 ? 'create-car-blod' : ''
      }
    },
    rentStandard() {
      const filterArr = this.carColor.filter((item) => Number(item.state) === 1)
      if (!this.carLicenseInfo.modelId || !this.carLicenseInfo.vin) {
        return false
      } else if (filterArr.length === 0) {
        return true
      } else {
        let sum = 0
        filterArr.forEach((item) => {
          if (item.parentKey) {
            // 因为图片是数组所以需要判断长度
            const isArray = this[item.parentKey][item.props] instanceof Array
            if (isArray) {
              if (this[item.parentKey][item.props].length) {
                sum++
              }
            } else if (
              this[item.parentKey][item.props] ||
              this[item.parentKey][item.props] === 0
            ) {
              sum++
            }
          } else {
            // 因为图片是数组所以需要判断长度
            const isArray = this[item.props] instanceof Array
            if (isArray) {
              if (this[item.props].length) {
                sum++
              }
            } else if (this[item.props] || this[item.props] === 0) {
              sum++
            }
          }
        })
        if (sum === filterArr.length) {
          return true
        } else {
          return false
        }
      }
    },
    isEdit() {
      return !!this.$route.query?.id
    },
  },
}
